import React from 'react';
import { Route, Routes } from 'react-router-dom';

import CXRouter from './mobile/CXRouter';
const MobileRouter = () => {
  return (
    <Routes>
      <Route path="/cx/*" element={<CXRouter />}></Route>
    </Routes>
  );
};

export default MobileRouter;
